/**
 * Owner: Masa Bayu
 * File: FlipIntentPanel.tsx
 * Date:Time: 2026-09-16 18:53
 * Description: T8-E5 Flip intent UI — packages only; QXReader executes Flip.
 */

import { useId, useState } from 'react';
import {
  createDemoFlipIntent,
  getDemoAdvancedStatus,
  getDemoFlipIntent,
  resetDemoAdvancedStore,
} from './demo-advanced-store';

export interface FlipIntentPanelProps {
  readonly onNavigate: (path: string) => void;
}

export function FlipIntentPanel({ onNavigate }: FlipIntentPanelProps) {
  const statusId = useId();
  const [status, setStatus] = useState(() => getDemoAdvancedStatus());
  const [intent, setIntent] = useState(() => getDemoFlipIntent());

  const refresh = (next: string) => {
    setStatus(next);
    setIntent(getDemoFlipIntent());
  };

  return (
    <section className="route-panel flip-intent" aria-labelledby="flip-intent-title">
      <h2 id="flip-intent-title">Flip · intent</h2>
      <p>QXRead packages Flip intents. Page-turn execution stays in QXReader.</p>
      <p id={statusId} role="status" aria-live="polite" className="flip-intent__status">
        {status}
        {intent !== null ? ` · kind ${intent.kind}` : ''}
      </p>
      <div role="group" aria-label="Flip intent actions" className="flip-intent__controls">
        <button
          type="button"
          onClick={() => {
            refresh(createDemoFlipIntent());
          }}
        >
          Package next Flip
        </button>
        <button
          type="button"
          onClick={() => {
            resetDemoAdvancedStore();
            refresh(getDemoAdvancedStatus());
          }}
        >
          Reset demo
        </button>
        <button
          type="button"
          onClick={() => {
            onNavigate('/motion');
          }}
        >
          Motion
        </button>
      </div>
      {intent !== null ? (
        <ul aria-label="Flip intent facts" className="flip-intent__facts">
          <li>{`executesInQxread=${String(intent.executesInQxread)}`}</li>
          <li>{`executesInQxReader=${String(intent.executesInQxReader)}`}</li>
          <li>{`mutatesQxp=${String(intent.mutatesQxp)}`}</li>
        </ul>
      ) : null}
    </section>
  );
}
